/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1EnvironmentsListEnvironmentsRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
};

/** @internal */
export type V1EnvironmentsListEnvironmentsRequestBody$Outbound = {
  project: string;
  app: string;
};

/** @internal */
export const V1EnvironmentsListEnvironmentsRequestBody$outboundSchema:
  z.ZodType<
    V1EnvironmentsListEnvironmentsRequestBody$Outbound,
    z.ZodTypeDef,
    V1EnvironmentsListEnvironmentsRequestBody
  > = z.object({
    project: z.string(),
    app: z.string(),
  });

export function v1EnvironmentsListEnvironmentsRequestBodyToJSON(
  v1EnvironmentsListEnvironmentsRequestBody:
    V1EnvironmentsListEnvironmentsRequestBody,
): string {
  return JSON.stringify(
    V1EnvironmentsListEnvironmentsRequestBody$outboundSchema.parse(
      v1EnvironmentsListEnvironmentsRequestBody,
    ),
  );
}
